import React from 'react';
export default (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    fill="currentColor"
  >
    <style type="text/css">{'.st0{clip-path:url(#SVGID_2_);}'}</style>
    <g>
      <defs>
        <rect id="SVGID_1_" width="24" height="24" />
      </defs>
      <clipPath id="SVGID_2_">
        <use xlinkHref="#SVGID_1_" style={{ overflow: 'visible' }} />
      </clipPath>
      <g className="st0">
        <path
          className="st1"
          d="M11.9,15.4c2.7,0,4.9-2.2,4.9-4.9c0-2.7-2.2-4.9-4.9-4.9c-2.7,0-4.9,2.2-4.9,4.9C6.9,13.2,9.1,15.4,11.9,15.4
			z M16.2,16.5h-1.9c-0.8,0.3-1.6,0.5-2.5,0.5c-0.9,0-1.7-0.2-2.5-0.5H7.5c-2.4,0-4.4,2-4.4,4.4v0.5c0,0.9,0.7,1.6,1.6,1.6H19
			c0.9,0,1.6-0.7,1.6-1.6v-0.5C20.6,18.4,18.7,16.5,16.2,16.5z"
        />
        <path
          className="st1"
          d="M10.9,0.4l-0.8,3.1c-0.1,0.3,0.1,0.5,0.4,0.6l5.9,1.6c0.3,0.1,0.5-0.1,0.6-0.4l0.8-3.1
			c0.1-0.4-0.3-0.8-0.7-0.6l-1.1,0.4c-0.3,0.1-0.6,0-0.7-0.3L15,0.6c-0.1-0.3-0.5-0.5-0.8-0.2l-1,0.8c-0.2,0.2-0.6,0.2-0.7-0.1
			l-0.7-0.9C11.6-0.1,11,0,10.9,0.4z"
        />
      </g>
    </g>
  </svg>
);
